/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useMemo } from 'react';
import { addDefaultSrc, formatMoney } from '../../helper/lib';
import moment from 'moment';
import AttachmentCard from './AttachmentCard';

const TabInformation = ({
  project,
  roomTypeExpress,
  tab,
  totalArea,
  totalCost,
}) => {
  const dataProject = project;

  const currentRoomPhotos = useMemo(
    () =>
      JSON.parse(dataProject?.roomInformation?.currentRoomPhotos)
        ?.filter((item) => item !== null)
        .map((item) => ({
          url: item,
          type: item?.split('.').pop(),
        })) ?? [],
    [dataProject?.roomInformation?.currentRoomPhotos]
  );

  const floorPlanPhotos = useMemo(
    () =>
      JSON.parse(dataProject?.roomInformation?.floorPlanPhotos)
        ?.filter((item) => item !== null)
        .map((item) => ({
          url: item,
          type: item?.split('.').pop(),
        })) ?? [],
    [dataProject?.roomInformation?.floorPlanPhotos]
  );

  const itemsToKeep = useMemo(
    () =>
      JSON.parse(dataProject?.roomInformation?.itemToKeep)
        ?.filter((item) => item !== null)
        .map((item) => ({
          url: item,
          type: item?.split('.').pop(),
        })) ?? [],
    [dataProject?.roomInformation?.itemToKeep]
  );

  const itemsToRemove = useMemo(
    () =>
      JSON.parse(project?.roomInformation?.itemToRemove)
        ?.filter((item) => item !== null)
        .map((item) => ({
          url: item,
          type: item?.split('.').pop(),
        })) ?? [],
    [project?.roomInformation?.itemToRemove]
  );

  const projectInspirations = useMemo(
    () =>
      JSON.parse(dataProject?.insporation?.inspiration)
        ?.filter((item) => item !== null)
        .map((item) => ({
          url: item,
          type: item?.split('.').pop(),
        })) ?? [],
    [dataProject?.insporation?.inspiration]
  );

  const inspirationLinks = useMemo(
    () =>
      JSON.parse(dataProject?.insporation?.inspirationLink)?.filter(
        (item) => item !== null
      ) ?? [],
    [dataProject?.insporation?.inspirationLink]
  );

  const itemsToAdd = useMemo(
    () =>
      JSON.parse(dataProject?.wishList?.itemToAdd)?.filter(
        (item) => item !== null
      ) ?? [],
    [dataProject?.wishList?.itemToAdd]
  );

  return (
    <div
      className={`tab-pane fade ${
        tab === 'designPlan' || tab === 'finalDesign' ? '' : 'show active'
      }`}
      id="information-temp"
      role="tabpanel"
      aria-labelledby="information-tab"
    >
      {/* Design Information */}
      <div className="mt-2 mb-4 d-flex justify-content-between align-items-center">
        <div className="fs-5 fw-bold">Design Information</div>{' '}
        {project?.projectInformatin?.so_invoice_url ? (
          <a
            href={project?.projectInformatin?.so_invoice_url}
            download
            className="btn btn-success"
          >
            Download Invoice
          </a>
        ) : null}
      </div>

      <table>
        <tbody>
          <tr className="align-top">
            <td width="150">
              <p className="fz-14 ff2">Project No</p>
            </td>
            <td>
              <p className="fz-14 fw-bold">
                {project?.projectInformatin?.orderNo ?? '-'}
              </p>
            </td>
          </tr>
          <tr className="align-top">
            <td width="150">
              <p className="fz-14 ff2">Service</p>
            </td>
            <td>
              <p className="fz-14 fw-bold">
                {project?.projectInformatin?.service ?? '-'}
              </p>
            </td>
          </tr>
          <tr className="align-top">
            <td width="150">
              <p className="fz-14 ff2">Status</p>
            </td>
            <td>
              <div className="badge-new mb-3 badge-gray">
                {project?.projectInformatin?.status ?? '-'}
              </div>
            </td>
          </tr>
          <>
            {roomTypeExpress?.map((room, index) => {
              return (
                <>
                  <tr key={'roomType1'} className="align-top">
                    <td width="150">
                      <p className="fz-14 ff2">Room Type {index + 1}</p>
                    </td>
                    <td>
                      <p className="fz-14 fw-bold">{room?.roomTypes ?? '-'}</p>
                    </td>
                  </tr>
                  <tr key={'roomType2'} className="align-top">
                    <td width="150">
                      <p className="fz-14 ff2">Area Type {index + 1}</p>
                    </td>
                    <td>
                      <p className="fz-14 fw-bold">
                        {room?.m2 ?? '-'}
                        {' m'}
                        <sup>2</sup>
                      </p>
                    </td>
                  </tr>
                  <tr key={'roomType3'} className="align-top">
                    <td width="150">
                      <p className="fz-14 ff2">Price Type {index + 1}</p>
                    </td>
                    <td>
                      <p className="fz-14 fw-bold">
                        {formatMoney(room?.project_price) ?? '-'}
                      </p>
                    </td>
                  </tr>
                </>
              );
            })}
          </>

          <tr className="align-top">
            <td width="150">
              <p className="fz-14 ff2">Name</p>
            </td>
            <td>
              <p className="fz-14 fw-bold">
                {project?.projectInformatin?.name ?? '-'}
              </p>
            </td>
          </tr>
          <tr className="align-top">
            <td width="150">
              <p className="fz-14 ff2">Phone Number</p>
            </td>
            <td>
              <p className="fz-14 fw-bold">
                {project?.projectInformatin?.phoneNumber ?? '-'}
              </p>
            </td>
          </tr>
          <tr className="align-top">
            <td width="150">
              <p className="fz-14 ff2">Email</p>
            </td>
            <td>
              <p className="fz-14 fw-bold">
                {project?.projectInformatin?.email ?? '-'}
              </p>
            </td>
          </tr>
          <tr className="align-top">
            <td width="150">
              <p className="fz-14 ff2">Total Area</p>
            </td>
            <td>
              <p className="fz-14 fw-bold">
                {totalArea ?? '-'} {' m'}
                <sup>2</sup>
              </p>
            </td>
          </tr>
          <tr className="align-top">
            <td width="150">
              <p className="fz-14 ff2">Total Cost</p>
            </td>
            <td>
              <p className="fz-14 fw-bold">
                {project?.total_order_price
                  ? formatMoney(project.total_order_price)
                  : totalCost
                  ? formatMoney(totalCost)
                  : '-'}
              </p>
            </td>
          </tr>
          <tr className="align-top">
            <td width="150">
              <p className="fz-14 ff2">Last Update</p>
            </td>
            <td>
              <p className="fz-14 fw-bold">
                {project?.projectInformatin?.updatedAt
                  ? moment(
                      project?.projectInformatin?.updatedAt.replaceAll(
                        ' WIB',
                        ''
                      ),
                      'ddd MMM DD HH:mm:ss YYYY',
                      true
                    ).format('ddd DD MMM YYYY HH:mm:ss ') + 'WIB'
                  : '-'}
              </p>
            </td>
          </tr>
        </tbody>
      </table>

      {/* Room Information, Wishlist, Inspiration, Budget */}
      {project?.projectInformatin?.status !== 'New Project' &&
        project?.projectInformatin?.status !== 'Cancelled' && (
          <div>
            <hr className="mt-5 mb-5" />
            <div className="fs-5 fw-bold mt-2 mb-4">Room Information</div>
            <table>
              <tbody>
                <tr className="align-top">
                  <td width="150">
                    <p className="fz-14 ff2">Residence Type</p>
                  </td>
                  <td>
                    <p className="fz-14 fw-bold ml-2">
                      {project?.roomInformation?.residenceType !== '' &&
                      project?.roomInformation?.residenceType
                        ? project?.roomInformation?.residenceType
                        : '-'}
                    </p>
                  </td>
                </tr>
                <tr className="align-top">
                  <td width="150" className="pe-2">
                    <p className="fz-14 ff2">
                      Why do Costumer want to decorate the room?
                    </p>
                  </td>
                  <td>
                    <p className="fz-14 fw-bold ml-2">
                      {project?.roomInformation?.aboutProject ?? '-'}
                    </p>
                  </td>
                </tr>
                <tr className="align-top">
                  <td width="150">
                    <p className="fz-14 ff2">Current Room Photos</p>
                  </td>
                  <td>
                    {currentRoomPhotos && currentRoomPhotos?.length > 0 ? (
                      <div className="row mb-3" style={{ gap: '15px' }}>
                        {currentRoomPhotos.map((item, index) => (
                          <AttachmentCard
                            index={index}
                            attachmentAlt={`currentRoomPhoto-${index}`}
                            attachmentUrl={item.url}
                            attachmentType={item.type}
                            dropdownMenuId={`currentRoomPhoto`}
                            note={
                              JSON.parse(project?.roomInformation?.crpNote)[
                                index
                              ]
                            }
                            onImageError={addDefaultSrc}
                          />
                        ))}
                      </div>
                    ) : (
                      <p className="fz-14 fw-bold ml-2">No photo upload</p>
                    )}
                  </td>
                </tr>
                <tr className="align-top">
                  <td width="150">
                    <p className="fz-14 ff2">Floor Plans</p>
                  </td>
                  <td>
                    {floorPlanPhotos && floorPlanPhotos?.length > 0 ? (
                      <div className="row mb-3" style={{ gap: '15px' }}>
                        {floorPlanPhotos.map((item, index) => (
                          <AttachmentCard
                            index={index}
                            attachmentAlt={`floorPlanPhoto-${index}`}
                            attachmentUrl={item.url}
                            attachmentType={item.type}
                            dropdownMenuId={`floorPlanPhoto`}
                            note={
                              JSON.parse(project?.roomInformation?.fpiNote)[
                                index
                              ]
                            }
                            onImageError={addDefaultSrc}
                          />
                        ))}
                      </div>
                    ) : (
                      <p className="fz-14 fw-bold ml-2">No photo upload</p>
                    )}
                  </td>
                </tr>
                <tr className="align-top">
                  <td width="150">
                    <p className="fz-14 ff2">Dimension</p>
                  </td>
                  <td>
                    <table>
                      <tbody>
                        <tr>
                          <td width="100">
                            <p className="fz-14 fw-bold ml-2">Width</p>
                          </td>
                          <td>
                            {project?.roomInformation?.dimensions && (
                              <p className="fz-14 fw-bold ml-2">
                                {
                                  JSON.parse(
                                    project?.roomInformation?.dimensions
                                  )[0]
                                }{' '}
                                m
                              </p>
                            )}
                          </td>
                        </tr>
                        <tr>
                          <td width="100">
                            <p className="fz-14 fw-bold ml-2">Length</p>
                          </td>
                          <td>
                            {project?.roomInformation?.dimensions && (
                              <p className="fz-14 fw-bold ml-2">
                                {
                                  JSON.parse(
                                    project?.roomInformation?.dimensions
                                  )[1]
                                }{' '}
                                m
                              </p>
                            )}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
                <tr className="align-top">
                  <td width="150">
                    <p className="fz-14 ff2">Items To Keep</p>
                  </td>
                  <td>
                    {itemsToKeep && itemsToKeep?.length > 0 ? (
                      <div className="row mb-3" style={{ gap: '15px' }}>
                        {itemsToKeep.map((item, index) => (
                          <AttachmentCard
                            index={index}
                            attachmentAlt={`itemsToKeep-${index}`}
                            attachmentUrl={item.url}
                            attachmentType={item.type}
                            dropdownMenuId={`itemsToKeep`}
                            note={
                              JSON.parse(project?.roomInformation?.itkNote)[
                                index
                              ]
                            }
                            onImageError={addDefaultSrc}
                          />
                        ))}
                      </div>
                    ) : (
                      <p className="fz-14 fw-bold ml-2">No photo upload</p>
                    )}
                  </td>
                </tr>
                <tr className="align-top">
                  <td width="150">
                    <p className="fz-14 ff2">Items To Remove</p>
                  </td>
                  <td>
                    {itemsToRemove && itemsToRemove?.length > 0 ? (
                      <div className="row mb-3" style={{ gap: '15px' }}>
                        {itemsToRemove.map((item, index) => (
                          <AttachmentCard
                            index={index}
                            attachmentAlt={`itemsToRemove-${index}`}
                            attachmentUrl={item.url}
                            attachmentType={item.type}
                            dropdownMenuId={`itemsToRemove`}
                            note={
                              JSON.parse(project?.roomInformation?.itrNote)[
                                index
                              ]
                            }
                            onImageError={addDefaultSrc}
                          />
                        ))}
                      </div>
                    ) : (
                      <p className="fz-14 fw-bold ml-2">No photo upload</p>
                    )}
                  </td>
                </tr>

                {project?.projectInformatin?.windowJs !== null &&
                  project?.projectInformatin?.windowJs !== '' &&
                  project?.projectInformatin?.windowJs !== undefined &&
                  project?.projectInformatin?.windowJs !== '[]' && (
                    <>
                      {JSON.parse(project?.projectInformatin?.windowJs)?.map(
                        (window, index) => {
                          return (
                            <tr key={index} className="align-top">
                              <td width="150">
                                <p className="fz-14 ff2">Window {index + 1}</p>
                              </td>
                              <td>
                                <table>
                                  <tbody>
                                    <tr>
                                      <td width="100">
                                        <p className="fz-14 fw-bold ml-2">
                                          Width
                                        </p>
                                      </td>
                                      <td>
                                        <p className="fz-14 fw-bold ml-2">
                                          {window?.width} cm
                                        </p>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td width="100">
                                        <p className="fz-14 fw-bold ml-2">
                                          Height
                                        </p>
                                      </td>
                                      <td>
                                        <p className="fz-14 fw-bold ml-2">
                                          {window?.height} cm
                                        </p>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          );
                        }
                      )}
                    </>
                  )}

                {(project?.projectInformatin?.windowJs === null ||
                  project?.projectInformatin?.windowJs === '' ||
                  project?.projectInformatin?.windowJs === undefined ||
                  project?.projectInformatin?.windowJs === '[]') && (
                  <tr className="align-top">
                    <td width="150">
                      <p className="fz-14 ff2">Window</p>
                    </td>
                    <td>
                      <p className="fz-14 fw-bold ml-2">-</p>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

            <hr className="mt-5 mb-5" />
            <div className="fs-5 fw-bold mt-2 mb-4">Wishlist</div>
            <table>
              <tbody>
                <tr className="align-top">
                  <td width="150">
                    <p className="fz-14 ff2">Items To Add</p>
                  </td>
                  <td>
                    {itemsToAdd && itemsToAdd.length > 0 ? (
                      <p className="fz-14 fw-bold ml-2">
                        {itemsToAdd.map((text, index, row) => (
                          <span key={index}>
                            {`${text}${index + 1 === row.length ? '.' : ', '}`}
                          </span>
                        ))}
                      </p>
                    ) : (
                      <p className="fz-14 fw-bold ml-2">-</p>
                    )}
                  </td>
                </tr>
                <tr className="align-top">
                  <td width="150">
                    <p className="fz-14 ff2">
                      Open To Use New Wall Color / Wallpaper
                    </p>
                  </td>
                  <td>
                    <p className="fz-14 fw-bold ml-2">
                      {project.wishList.openToUseNew ?? '-'}
                    </p>
                  </td>
                </tr>
                <tr className="align-top">
                  <td width="150">
                    <p className="fz-14 ff2 mb-2">Color Tone</p>
                  </td>
                  <td>
                    <div className="row mb-2">
                      <div className="col-3 rounded border p-3">
                        <a className="text-center image-component">
                          <img
                            src={
                              project.wishList.colorTone
                                ? `${project.wishList.colorTone}`
                                : ''
                            }
                            style={{
                              maxWidth: '220px !important',
                              height: '220px',
                              objectFit: 'cover',
                            }}
                            alt="img-inspiration"
                            onError={addDefaultSrc}
                          />
                        </a>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr className="align-top">
                  <td width="150">
                    <p className="fz-14 ff2 mt-2">Color Preference</p>
                  </td>
                  <td>
                    <p className="fz-14 fw-bold my-2">
                      {project.wishList.colorPreference ?? '-'}
                    </p>
                  </td>
                </tr>
                <tr className="align-top">
                  <td width="150">
                    <p className="fz-14 ff2">Specific Audience</p>
                  </td>
                  <td>
                    <p className="fz-14 fw-bold ml-2">
                      {project.wishList.specificAudience ?? '-'}
                    </p>
                  </td>
                </tr>
                <tr className="align-top">
                  <td width="150">
                    <p className="fz-14 ff2">
                      Anything Else Costumer Like To See In Your Design?
                    </p>
                  </td>
                  <td>
                    <p className="fz-14 fw-bold ml-2">
                      {project.wishList.wishlistQuetion !== '' &&
                      project.wishList.wishlistQuetion
                        ? project.wishList.wishlistQuetion
                        : '-'}
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>

            <hr className="mt-5 mb-5" />
            <div className="fs-5 fw-bold mt-2 mb-4">Inspiration</div>
            <table>
              <tbody>
                <tr className="align-top">
                  <td width="150">
                    <p className="fz-14 ff2">Inspiration Link</p>
                  </td>
                  <td>
                    {inspirationLinks && inspirationLinks?.length > 0 ? (
                      <>
                        {inspirationLinks.map((item, index) => (
                          <>
                            <>
                              <a
                                key={index}
                                href={item.url}
                                target="_blank"
                                className="fz-14 fw-bold ml-2"
                                rel="noreferrer"
                              >
                                <u>{item.url}</u>
                              </a>
                              <br />
                            </>
                          </>
                        ))}
                      </>
                    ) : (
                      <p className="fz-14 fw-bold ml-2">-</p>
                    )}
                  </td>
                </tr>
                <tr className="align-top">
                  <td width="150">
                    <p className="fz-14 ff2 mt-2">Inspiration</p>
                  </td>

                  <td>
                    {projectInspirations && projectInspirations?.length > 0 ? (
                      <div className="row mb-3 mt-2" style={{ gap: '15px' }}>
                        {projectInspirations.map((item, index) => (
                          <AttachmentCard
                            index={index}
                            attachmentAlt={`projectInspiration-${index}`}
                            attachmentUrl={item.url}
                            attachmentType={item.type}
                            dropdownMenuId={`projectInspiration`}
                            note={
                              JSON.parse(project?.insporation?.inspirationNote)[
                                index
                              ]
                            }
                            onImageError={addDefaultSrc}
                          />
                        ))}
                      </div>
                    ) : (
                      <p className="fz-14 fw-bold my-2">No photo upload</p>
                    )}
                  </td>
                </tr>
              </tbody>
            </table>

            <hr className="mt-5 mb-5" />
            <div className="fs-5 fw-bold mt-2 mb-4">Budget</div>
            <table>
              <tbody>
                <tr className="align-top">
                  <td width="150">
                    <p className="fz-14 ff2">Budget Range</p>
                  </td>
                  <td>
                    <p className="fz-14 fw-bold ml-2">
                      Rp {project.budget.budgetRange ?? '0'}
                    </p>
                  </td>
                </tr>
                <tr className="align-top">
                  <td width="150">
                    <p className="fz-14 ff2">Budget Description</p>
                  </td>
                  <td>
                    <p className="fz-14 fw-bold ml-2">
                      {project.budget.budgetDesc ?? '-'}
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        )}
    </div>
  );
};

export default TabInformation;
